// Public landing snippet of the Portfolio Assistant (beta) — a stripped-down,
// static transposition of the in-app panel. Marketing discipline per spec §11:
// mechanical description, no advisory framing, caption on the visual.
import { MessageSquare } from "lucide-react";

const MONO = "'JetBrains Mono', monospace";

const Bubble = ({ side, children, C }) => (
  <div className={`flex ${side === "user" ? "justify-end" : "justify-start"}`}>
    <div className="max-w-[88%] px-2.5 py-1.5 rounded-md text-[10px] leading-relaxed"
      style={side === "user"
        ? { background: "rgba(0,200,150,0.10)", color: C.text, border: `1px solid rgba(0,200,150,0.25)` }
        : { background: C.cardAlt, color: C.muted, border: `1px solid ${C.border}` }}>
      {children}
    </div>
  </div>
);

export const AssistantShowcase = ({ C }) => (
  <div className="rounded-lg overflow-hidden flex flex-col" style={{ background: C.card, border: `1px solid ${C.border}` }}
    data-testid="assistant-showcase">
    <div className="px-4 pt-3 pb-2 flex items-center justify-between flex-wrap gap-1" style={{ borderBottom: `1px solid ${C.border}` }}>
      <span className="text-[10px] font-bold uppercase tracking-[0.15em] inline-flex items-center gap-1.5"
        style={{ color: C.muted, fontFamily: MONO }}>
        <MessageSquare className="w-3 h-3" style={{ color: C.accent }} />
        Portfolio Assistant
        <span className="text-[8px] px-1 py-px rounded font-bold" style={{ background: "rgba(0,200,150,0.12)", color: C.accent }}>BETA</span>
      </span>
      <span className="text-[8px] px-1.5 py-0.5 rounded-sm font-bold" style={{ background: "rgba(0,0,0,0.5)", color: "#a3a3a3", fontFamily: MONO }}>
        SAMPLE — NOT A LIVE ACCOUNT
      </span>
    </div>
    <div className="px-3 py-3 space-y-2">
      <Bubble side="user" C={C}>Check my portfolio for downside protection.</Bubble>
      <Bubble side="assistant" C={C}>
        <span className="font-bold" style={{ color: C.text }}>Downside risk readout — sample account</span>
        <span className="block mt-1">
          VaR (95%, 14-day horizon): <span style={{ color: "#f87171", fontFamily: MONO }}>$4,310</span> (4.2% of NLV) ·
          CVaR: <span style={{ color: "#f87171", fontFamily: MONO }}>$6,905</span> ·
          Floor-breach probability: <span style={{ fontFamily: MONO, color: C.text }}>3.1%</span>
        </span>
        <span className="block mt-1">
          <span style={{ color: C.text }}>Scenario tests:</span> 1 of 4 stress scenarios would breach the configured floor —
          GFC-like (−55%): stressed NLV <span style={{ fontFamily: MONO }}>$61,400</span> vs floor <span style={{ fontFamily: MONO }}>$87,200</span>.
        </span>
        <span className="block mt-1">
          <span style={{ color: C.text }}>Hedge inventory:</span> 2 of 6 equity positions have no protective put: BA (700 sh), WFC (1,000 sh).
        </span>
        <span className="block mt-1.5 pt-1.5 text-[8.5px] italic" style={{ borderTop: `1px dashed ${C.border}`, color: "#555" }}>
          Informational only — not a recommendation to buy, sell, or hold any security. Computed from: Portfolio Risk engine · scenario suite · your configured Settings.
        </span>
      </Bubble>
      <Bubble side="user" C={C}>OK but should I hedge? Just tell me yes or no.</Bubble>
      <Bubble side="assistant" C={C}>
        That decision is yours — MarkovLab is an analytics tool, not an adviser, so I can't tell you what to do.
        What I can do: re-run the readout with different assumptions, show the formula behind any number, or link
        you to the Settings that drive these thresholds.
      </Bubble>
    </div>
    <div className="px-4 py-2 text-[9px] border-t" style={{ color: "#555", borderColor: C.border }}>
      Sample exchange, illustrative only. The Assistant reads out what your own engines and Settings compute — it never gives recommendations.
    </div>
  </div>
);
